// Mock data for CASA BALA restaurant - using actual assets
import { MENU_DATA } from "./menu_data.js";
import {
  HERO_IMAGE,
  RESTAURANT_INTERIOR,
  WINES_AND_LOGO,
  GARDEN,
  PROSECCO_BAR,
  MEATBALLS,
  PIZZA_FOOTER,
  casabala_3,           
  CB_BASE,
  MENU_SECTION_IMAGES,
  GALLERY_PHOTOS,
} from "./assets";

// ============================================
// ИНФОРМАЦИЯ ЗА РЕСТОРАНТА (САМО ДАННИ, БЕЗ ПРЕВОД)
// ============================================

// mock.js
export const restaurantInfo = {
  name: "CASA BALA",
  address: 'бул. "Симеоновско шосе" 4',
  city: "София, България",
  email: "r.casabala@gmail.com",
  phone: "+359 879201010",
};

// ============================================
// НАВИГАЦИОННИ ВРЪЗКИ (САМО ПЪТОВЕ, ЕТИКЕТИТЕ СА В i18n)
// ============================================

export const navLinks = [
  { key: "nav.home", path: "/" },
  { key: "nav.menu", path: "/menu" },
  { key: "nav.reservation", path: "/reservation" },
  { key: "nav.order", path: "/order" },
  { key: "nav.gallery", path: "/gallery" },
  { key: "nav.events", path: "/events" },
  { key: "nav.about", path: "/about" },
  { key: "nav.contact", path: "/contact" },
];

// ============================================
// ОФЕРТИ (HOMEPAGE) - САМО ДАННИ
// ============================================

export const offerings = [
  {
    key: "offerings.experience",
    ctaKey: "offerings.experience_cta",
    link: "/reservation",
    image: casabala_3,
  },
  {
    key: "offerings.tastes",
    ctaKey: "offerings.see_menu",
    link: "/menu",
    image: MEATBALLS,
  },
  {
    key: "offerings.wine",
    ctaKey: "offerings.see_menu",
    link: "/menu",
    image: PROSECCO_BAR,
  },
];

// ============================================
// ХАРАКТЕРИСТИКИ (FEATURES) - САМО ДАННИ
// ============================================

export const features = [
  { titleKey: "features.fresh", descKey: "features.fresh_desc", icon: "Leaf" },
  { titleKey: "features.tastes", descKey: "features.tastes_desc", icon: "UtensilsCrossed" },
  { titleKey: "features.chefs", descKey: "features.chefs_desc", icon: "ChefHat" },
  { titleKey: "features.events", descKey: "features.events_desc", icon: "Calendar" },
];

// ============================================
// КАТЕГОРИИ ЗА МЕНЮТО (САМО КЛЮЧОВЕ)
// ============================================

export const menuCategories = [
  { key: "MAIN", labelKey: "cat.MAIN", icon: "UtensilsCrossed" },
  { key: "SALAD", labelKey: "cat.SALAD", icon: "Salad" },
  { key: "STARTER", labelKey: "cat.STARTER", icon: "Soup" },
  { key: "SOUP", labelKey: "cat.SOUP", icon: "Soup" },
  { key: "PASTA", labelKey: "cat.PASTA", icon: "Wheat" },
  { key: "RISOTTO", labelKey: "cat.RISOTTO", icon: "CookingPot" },
  { key: "PIZZA", labelKey: "cat.PIZZA", icon: "Pizza" },
  { key: "SIDES", labelKey: "cat.SIDES", icon: "Apple" },
  { key: "BREAD", labelKey: "cat.BREAD", icon: "Croissant" },
  { key: "DESSERT", labelKey: "cat.DESSERT", icon: "CakeSlice" },
];

// ============================================
// СЕКЦИИ ЗА ГЛАВНАТА СТРАНИЦА НА МЕНЮТО
// ============================================

export const menuSections = [
  {
    key: "menu.lunch",
    subtitleKey: "menu.lunch_hours",
    descKey: "menu.lunch_desc",
    ctaKey: "menu.see_menu",
    image: MENU_SECTION_IMAGES.LUNCH,
    link: "/menu/lunch"
  },
  {
    key: "menu.main",
    descKey: "menu.main_desc",
    ctaKey: "menu.see_menu",
    image: MENU_SECTION_IMAGES.MAIN,
    link: "/menu/items"
  },
  {
    key: "menu.drinks",
    descKey: "menu.drinks_desc",
    ctaKey: "menu.see_menu",
    image: MENU_SECTION_IMAGES.DRINKS,
    link: "/menu/drinks"
  },
  {
    key: "menu.alcohol",
    descKey: "menu.alcohol_desc",
    ctaKey: "menu.see_menu",
    image: MENU_SECTION_IMAGES.ALCOHOL,
    link: "/menu/alcohol"
  },
];

// ============================================
// ГАЛЕРИЯ
// ============================================

export const galleryImages = GALLERY_PHOTOS;

// ============================================
// СЪБИТИЯ
// ============================================

export const events = [
  {
    titleKey: "events.wine_evenings",
    dateKey: "events.every_friday",
    descKey: "events.wine_evenings_desc",
    image: PROSECCO_BAR,
  },
  {
    titleKey: "events.live_music",
    dateKey: "events.every_saturday",
    descKey: "events.live_music_desc",
    image: casabala_3,    
  },
  {
    titleKey: "events.private_events",
    dateKey: "events.by_request",
    descKey: "events.private_events_desc",
    image: RESTAURANT_INTERIOR,
  },
  {
    titleKey: "events.culinary_classes",
    dateKey: "events.once_monthly",
    descKey: "events.culinary_classes_desc",
    image: GARDEN,
  },
];

// ============================================
// ПОМОЩНИ ФУНКЦИИ ЗА РАБОТА С МЕНЮТО
// ============================================

// Helper function to parse price string
const parsePrice = (str) => {
  if (!str) return { eur: "", bgn: "" };
  const m = str.match(/([\d.,]+)\s*€/);
  if (m) return { eur: m[1].replace(",", "."), bgn: "" };
  return { eur: "", bgn: "" };
};

// Build menuItems from MENU_DATA (без превод, само данни)
export const menuItems = Object.fromEntries(
  Object.entries(MENU_DATA).map(([cat, arr]) => [
    cat,
    arr.map((it) => {
      const p = parsePrice(it.price);
      return {
        nameBg: it.name,
        nameEn: it.name_en || it.name,
        descBg: it.desc || "",
        descEn: it.desc_en || it.desc || "",
        weight: it.weight || "",
        priceEur: p.eur,
        priceBgn: p.bgn,
        priceRaw: it.price,
        image: it.img || "",
      };
    }),
  ])
);

// Функция за вземане на menuItems с преведени имена и описания
export const getMenuItems = (lang) => {
  const localizedItems = {};
  Object.entries(menuItems).forEach(([cat, items]) => {
    localizedItems[cat] = items.map(item => ({
      ...item,
      name: lang === 'en' ? item.nameEn : item.nameBg,
      desc: lang === 'en' ? item.descEn : item.descBg,
    }));
  });
  return localizedItems;
};